/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from '@/shared/api/axios-client'
import type { GetStatsByDriversReportQueryResponse, GetStatsByDriversReportQueryParams, GetStatsByDriversReport400 } from '../entities/GetStatsByDriversReport'
import type { RequestConfig, ResponseErrorConfig } from '@/shared/api/axios-client'

function getGetStatsByDriversReportUrl() {
  return `/stats/by-drivers/report` as const
}

/**
 * @description Получение отчета по статистике по водителям
 * @summary Получение отчета по статистике по водителям
 * {@link /stats/by-drivers/report}
 */
export async function getStatsByDriversReport(params?: GetStatsByDriversReportQueryParams, config: Partial<RequestConfig> & { client?: typeof client } = {}) {
  const { client: request = client, ...requestConfig } = config

  const res = await request<GetStatsByDriversReportQueryResponse, ResponseErrorConfig<GetStatsByDriversReport400>, unknown>({
    method: 'GET',
    url: getGetStatsByDriversReportUrl().toString(),
    params,
    ...requestConfig,
  })
  return res.data
}